import commonActionTypes from './action-types';

export const setContext = value => ({
  type: commonActionTypes.SET_CONTEXT,
  payload: value,
});

export const fetchStaticData = payload => ({
  type: commonActionTypes.FETCH_STATIC_DATA,
  payload,
});

export const fetchStaticDataSuccess = payload => ({
  type: commonActionTypes.FETCH_STATIC_DATA_SUCCESS,
  payload,
});

export const fetchStaticDataFail = payload => ({
  type: commonActionTypes.FETCH_STATIC_DATA_FAIL,
  payload,
});

export const fetchCompanyProfilesList = payload => ({
  type: commonActionTypes.FETCH_COMPANY_PROFILES_LIST,
  payload,
});

export const fetchCompanyProfilesListSuccess = payload => ({
  type: commonActionTypes.FETCH_COMPANY_PROFILES_LIST_SUCCESS,
  payload,
});

export const fetchCompanyProfilesListFail = payload => ({
  type: commonActionTypes.FETCH_COMPANY_PROFILES_LIST_FAIL,
  payload,
});

export const resetCompanyProfilesList = payload => ({
  type: commonActionTypes.RESET_COMPANY_PROFILES_LIST,
  payload,
});

export const setSelectedCompanyProfile = payload => ({
  type: commonActionTypes.SET_SELECTED_COMPANY_PROFILE,
  payload,
});
